import { render, staticRenderFns } from "./RaBaseForm.vue?vue&type=template&id=7086eb72&scoped=true"
import script from "./RaBaseForm.vue?vue&type=script&lang=js"
export * from "./RaBaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7086eb72",
  null
  
)

export default component.exports